export const playTmpAudio = (tmpAudioUrl: string): Promise<void> => {
  return new Promise<void>((resolve, reject) => {
    let audio: HTMLAudioElement | null = document.createElement('audio')

    const cleanup = () => {
      if (audio) {
        audio.removeEventListener('ended', onEnded)
        audio.removeEventListener('canplaythrough', playAudio)
        audio.removeEventListener('error', onError)
        audio = null
      }
    }

    const playAudio = () => {
      if (!audio) return // safety check
      audio.play().catch((err: Error) => {
        console.log('Failed to play audio:', err)
        cleanup()
        reject(err) // reject the promise if play fails
      })
    }

    const onEnded = () => {
      cleanup()
      resolve() // resolve the promise when audio ends
    }

    const onError = (event: Event) => {
      cleanup()
      reject(new Error('Failed to load audio. Possible 404 or network error.')) // reject on load error
    }

    audio.addEventListener('canplaythrough', playAudio, { once: true }) // play audio when can play through
    audio.addEventListener('ended', onEnded, { once: true }) // resolve promise when audio ends
    audio.addEventListener('error', onError, { once: true }) // reject promise on error

    audio.src = tmpAudioUrl // this starts loading the audio data
  })
}
